/*
 * 项目回款弹框组件
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
*/

import { useState, useEffect } from 'react';
import {
    Modal,
    Button,
    message,
    Image,
    Statistic,
    Tag,
    theme,
    Flex,
} from 'antd';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Html2pdf,
    AddRequestHeaders,
    UjoinParams,
    AliyunOSSclient,
    defaultImage,
    BrandUrl,
    SloganUrl,
} from '../../incs/FunHelper.js';

/**
 * 显示项目回款信息
 * @param {*} props 
 * @returns 
 */
const RepaymentInfo = (props) => {
    const { open, setOpen, record, preGroup } = props;

    const cancel = () => { setOpen(false, null); setImageList([]) }
    const [imageList, setImageList] = useState([]);

    const {
        token: {
            colorSuccess,
            colorSuccessBg,
        },
    } = theme.useToken();

    const printer = () => {
        var printContents = document.getElementById('print-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };

    const download = () => { Html2pdf('print-info-id', record.project_name + '.' + record.date, imageList.length > 0 ? true : false); };

    /**
     * 获取图片列表
     */
    const getImageLists = (imageUri) => {
        let _imageList = [];
        let params = {
            'acl': 'GetObject'
        }
        $.ajax({
            url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    const token = data.dat;
                    let imageUris = imageUri.split(',');
                    for (let i = 0; i < imageUris.length; i++) {
                        let item = imageUris[i];
                        try {
                            //  去掉路径‘/’
                            let result = AliyunOSSclient(token).signatureUrl(item, {
                                expires: 3600,
                                response: {
                                    'content-disposition': 'attachment; filename="' + item.split('/').pop() + '"'
                                }
                            });
                            _imageList.push({
                                url: result,
                                preview: result,
                                status: 'done',
                                percent: 100,
                                path: item,
                                uid: i + 1,
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    }
                    setImageList(_imageList);
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    useEffect(() => {
        if (record.image_uri) {
            getImageLists(record.image_uri);
        }
    }, [record]);
    return (
        <>
            <Modal
                width={820}
                style={{ top: 0 }}
                closable={false}
                open={open}
                keyboard={true}
                onCancel={cancel}
                footer={[
                    <Button key='back' onClick={cancel}>取消</Button>,
                    <Button key='printer' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download} style={{ marginRight: 20 }}>下载</Button>,
                ]}
            >
                <div id='print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <Flex justify='space-between' style={{ marginBottom: '10px' }}>
                            <img src={BrandUrl} height='35px' alt={preGroup || CNF.companyShortName} />
                            <img src={SloganUrl} height='35px' alt={preGroup || CNF.companyShortName} />
                        </Flex>
                        <table width='100%'>
                            <thead align='center'>
                                <tr>
                                    <th colSpan='24'><h2>项目回款明细</h2></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>项目名称</td><td colSpan='19' style={{ width: 600 }}>{record.project_name}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>项目编号</td><td colSpan='19' style={{ width: 600 }}>{record.project_number}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>回款金额</td><td colSpan='8' style={{ width: 240 }}><Tag color={colorSuccessBg}><Statistic precision={CNF.DPL} suffix={record.amount > 10000 ? '万元' : '元'} styles={{ content: { fontSize: CNF.fontSize - 2, color: colorSuccess } }} value={record.amount >= 10000 ? record.amount / 10000 : record.amount} /></Tag></td>
                                    <td colSpan='4' style={{ width: 120 }}>回款日期</td><td colSpan='8' style={{ width: 240 }}>{record.date}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>付款方户名</td><td colSpan='8' style={{ width: 240 }}>{record.payer_name}</td>
                                    <td colSpan='4' style={{ width: 120 }}>付款方账户</td><td colSpan='8' style={{ width: 240 }}>{record.payer_account}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>收款方户名</td><td colSpan='8' style={{ width: 240 }}>{record.beneficiary_name}</td>
                                    <td colSpan='4' style={{ width: 120 }}>收款方账户</td><td colSpan='8' style={{ width: 240 }}>{record.beneficiary_account}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>回款人员</td><td colSpan='19' style={{ width: 600 }}>{record.personnel}</td>
                                </tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>备注:</td><td colSpan='19' style={{ width: 600 }}>
                                    {record.description && record.description.split('\n').map((item, index) => {
                                        return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                    })}
                                </td></tr>
                            </tbody>
                        </table>
                        <div>
                            {
                                imageList.length > 0 ? <p>附图: </p> : ''
                            }
                            {
                                imageList && imageList.map((item, index) => {
                                    return <Image
                                        className='whole-node'
                                        key={index}
                                        alt={CNF.companyShortName}
                                        width='33.3%'
                                        src={item.url}
                                        style={{ verticalAlign: 'top', maxWidth: '100%', height: 'auto' }}
                                        fallback={defaultImage}
                                    />
                                })
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default RepaymentInfo